import React from 'react';
import UserProfile from '../../../../app/components/UserProfile';

export default class Topbar extends React.Component {
    render() {
        return (
            <div className="kt-header__topbar d-flex align-items-center">
                {<UserProfile showAvatar={false} showHi={true} showBadge={false} />}
            </div>
        );
    }
}
